// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media(max-width:960px){.spaces[data-v-35069953]{display:flex;flex-direction:column;padding-bottom:24px}}.spaces .secondary-button.add[data-v-35069953]{width:auto;margin-top:28px}.spaces .venue[data-v-35069953]{margin-bottom:28px}", ""]);
// Exports
module.exports = exports;
